<template>
	<v-stepper elevation="0" non-linear v-model="passoAtual" class="aditivo-apostila-stepper">
		<div class="aditivo-apostila-stepper-header-container">
			<v-stepper-header elevation="0" class="aditivo-apostila-stepper-header">
				<div v-for="step in steps" :key="step.num" class="aditivo-apostila-stepper-step">
					<v-stepper-step class="color-titulo" :complete="passoAtual > step.num" :editable="isEditable" :step="step.num"
					>{{ step.nome }}
					</v-stepper-step>
					<v-divider v-if="!ehUltimoStep(step.num)"></v-divider>
				</div>
			</v-stepper-header>
		</div>
		<v-divider></v-divider>
		<v-stepper-items>
			<v-stepper-content :step="step.num" v-for="step in steps" :key="step.num">
				<slot :name="`step-${step.num}`"></slot>
			</v-stepper-content>
		</v-stepper-items>
	</v-stepper>
</template>
<script>
export default {
	name: 'stepper-aditivo-apostila',
	props: {
		steps: {
			type: Array,
			required: true,
		},
		stepAtual: {
			type: Number,
			default: 1,
		},
		editable: {
			type: Boolean,
		},
	},
	computed: {
		passoAtual: {
			get() {
				return this.stepAtual
			},
			set(passoAtual) {
				this.$emit('step-alterado', passoAtual)
			},
		},
		isEditable() {
			return this.editable
		},
	},
	methods: {
		ehUltimoStep(step) {
			return step === this.steps.length
		},
	},
}
</script>
<style lang="stylus">
.aditivo-apostila-stepper
	box-shadow: none !important;
	border: none !important;

.aditivo-apostila-stepper-header-container
	width: 100%;
	display: flex;
	justify-content: center;

.aditivo-apostila-stepper-header
	display: flex;
	justify-content: center !important;
	box-shadow: none !important;
	border: none !important;

.aditivo-apostila-stepper-step
	display: flex;

.aditivo-apostila-stepper-step hr
	margin: 0;
	width: 100px;

.aditivo-apostila-stepper-step .v-stepper__step--active div
	color: var(--v-primary-base) !important;
</style>
